<template lang="pug">
  el-tree(
    class="smart-tree"
    show-checkbox
    node-key="value"
    :accordion="true"
    :data="treeData"
    :default-checked-keys="Array.from(currentValue)"
    @node-click="treeNodeClick"
    @check-change="treeChangeValue")
</template>

<script>
// import { dataTypeFunc } from '@/utils/common'
import { treeFormat } from '@/utils/common'

export default {
  name: 'SmartTree',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    live: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      treeData: treeFormat(this.options, 'value'),
      currentValue: new Set(this.value)
    }
  },
  methods: {
    treeChangeValue (data, state, child) {
      let currentValue = this.currentValue
      state && !data.children ? currentValue.add(data.value) : currentValue.delete(data.value)
      this.$emit('input', Array.from(currentValue))
    },
    treeNodeClick (data, state, child) {
      let currentValue = this.currentValue
      this.$emit('treesClick', Array.from(currentValue))
    }
  }
}
</script>

<style scoped lang="sass">
.smart-tree
  border: 1px solid rgba(0, 0, 0, 0.07)
  width: 100%
  height: 182px
  overflow: auto
</style>



// WEBPACK FOOTER //
// SmartTree.vue?c44bc6f8